/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { PALETTE } from "styles/base/variables";

interface SubtitleCardProps {
  children: React.ReactNode;
}

function SubtitleCard({ children }: SubtitleCardProps) {
  return (
    <div
      css={css`
        margin-left: 20px;
        padding: 6px 10px;
        background-color: ${PALETTE.light};
        border-radius: 50px;
        display: flex;
        gap: 10px;
      `}
    >
      {children}
    </div>
  );
}

export default SubtitleCard;
